<template>
  <div>
    <div class="selvideo_left">
      <div class="selvideo_left_con">
        <el-input
          prefix-icon="el-icon-search"
          style="width: 90%; margin-top: 6%; margin-bottom: 6%"
          placeholder="请输入搜索内容"
          v-model="audioName"
          size="small"
          @change="searchAudio"
        ></el-input>
      </div>
      <div class="selvideo_left_tree">
        <el-tree
          v-if="isShow"
          @check-change="handleCheckChange"
          class="filter-tree"
          show-checkbox
          :data="setData"
          node-key="uuid"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :default-checked-keys="renderKeys"
          ref="tree2"
        ></el-tree>
        <div class="select_pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            layout="total, prev, pager, next"
            :page-size="limit"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="selvideo_right">
      <div class="swicth_con">
        <div class="sw_tip">
          <span v-text="'已选' + this.title + ' (' + this.selNum + ') '"></span>
          <span class="clear_btn" @click="reset">清空</span>
        </div>
        <ul>
          <li v-for="(item, index) in renderList" :key="index">
            <span v-text="item[param]"></span>
            <i class="icon-del" @click="delPerson(item)"></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import vue from "@/main";
import { getNoRAudio } from "@/api/audioSet";
export default {
  data() {
    return {
      selNum: 0,
      renderList: [],
      limit: 10,
      page: 1,
      total: 0,
      audioName: "",
      isShow: false,
      treeData: [],
      setData: [],
      selectedMembers: [],
      defaultProps: {
        children: "children",
        label: "",
      },
      audioSetId: ""
    };
  },
  props: ["renderData", "renderKeys", "title", "param"],
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    },
    renderList() {
      this.isShow = true;
    },
  },
  created() {
    vue.$on("setAudioManage", (data, audioSetId) => {
      this.audioSetId = audioSetId || "";
      (this.total = data.total), (this.setData = data.records);
    });
  },
  mounted() {
    this.defaultProps.label = this.param;
    this.defaultProps.value = "uuid";
    this.initCheckNodes();
  },
  methods: {
    handleCurrentChange(p) {
      this.page = p;
      this.getMembers();
    },
    searchAudio() {
      this.page = 1;
      this.getMembers();
    },
    // 获取视频：全部节点数据
    getMembers() {
      let params = {
        page: this.page,
        audioSetId: this.audioSetId,
        audioName: this.audioName,
        limit: this.limit,
      };
      getNoRAudio(params).then((res) => {
        if (!res || res.code != 0) return;
        this.setData = res.data.records;
        this.total = res.data.total;
      });
      if (this.renderList.length > 0) {
        this.$nextTick(() => {
          this.$refs["tree2"].setCheckedKeys(this.renderList.map((ele) => ele.uuid));
        });
      }
    },
    delPerson(item) {
      for (var i = 0; i < this.renderList.length; i++) {
        if (this.renderList[i].uuid == item.uuid) {
          this.renderList.splice(i, 1);
        }
      }
      this.$refs.tree2.setCheckedNodes(this.renderList);
      this.selNum = this.renderList.length;
    },
    initCheckNodes() {
      this.isShow = true;
      this.renderList = this.renderData;
      this.selNum = this.renderList.length;

      this.$nextTick(() => {
        this.$refs.tree2.setCheckedKeys(this.renderList.map((ele) => ele.uuid));
      });
    },
    handleCheckChange(data, checked, node) {
      if (checked) {
        this.renderList.push(data);
        // this.selectedMembers = this.unin(this.selectedMembers);
      } else {
        this.renderList.forEach((ele, i) => {
          if (ele.uuid == data.uuid) {
            this.renderList.splice(i, 1);
            return;
          }
        });
      }
      // this.renderList = this.$refs.tree2.getCheckedNodes();
      this.selNum = this.renderList.length;
      this.$emit("change-sel", this.renderList);
    },
    //树结构搜索
    filterNode(value, data) {
      if (!value) return true;
      return data.videoName.indexOf(value) !== -1;
    },
    reset() {
      this.renderList = [];
      this.selNum = 0;
      this.$refs.tree2.setCheckedNodes([]);
      this.$emit("change-sel", this.renderList);
    },
  },
};
</script>

<style lang="scss" scoped>
.swicth_con {
  width: 100%;
  height: 300px;
  border: 1px solid rgb(235, 238, 245);
  border-radius: 2px;
  ul {
    height: 260px;
    overflow: auto;
    margin: 0;
    list-style: none;
    padding: 10px 0;
    box-sizing: border-box;
    li {
      line-height: 30px;
      width: 100%;
      display: inline-block;
      padding: 0 10px;
      box-sizing: border-box;
      color: #51627d;
      i {
        float: right;
        line-height: 30px;
      }
    }
    li:hover {
      background: rgba(242, 243, 244, 1);
    }
  }
}
.sw_tip {
  display: inline-block;
  line-height: 40px;
  padding-left: 10px;
  background-color: #f2f3f4;
  width: 100%;
  color: #343c4a;
  box-sizing: border-box;
  .clear_btn {
    float: right;
    padding-right: 10px;
    color: #96a1b2;
    cursor: pointer;
  }
}
.icon-del {
  height: 30px;
  width: 30px;
  background: url("../../assets/image/btn/icon_delete@2x.png") no-repeat;
  background-size: 12px 12px;
  background-position: center;
  cursor: pointer;
}
.selvideo_left {
  text-align: center;
  width: 35%;
  height: 300px;
  float: left;
  border: 1px solid #ebeef5;
  margin-left: 10%;
  margin-right: 10%;
}
.selvideo_left_con {
  width: 100%;
  background-color: white;
}
.selvideo_left_tree {
  height: 234px;
  background-color: white;
}
.filter-tree {
  height: 200px;
  width: 100%;
  overflow-y: auto;
}
.selvideo_right {
  text-align: left;
  width: 35%;
  float: left;
}
.select_pagination {
  width: 98%;
  height: 50px;
  overflow-x: auto;
}
</style>
